import { ImMNElement, MNElement } from '../elementModelTypes';
import { ImmutableOrArray, toArray } from '../../utils/immutableHelper';
import { getLabels } from './elementPropertyUtils';
import { getUniqueArray } from '../../utils/arrayUtils';
import { isString } from 'lodash';

/**
 * Collects the unique string label IDs used by the provided elements.
 */
export const getUniqueUsedLabelIds = (elements?: ImmutableOrArray<MNElement | ImMNElement>): string[] => {
    const elementArray = toArray<MNElement | ImMNElement>(elements) || [];
    const labelIdArray = elementArray.flatMap((element) => toArray(getLabels(element)) || []);
    return getUniqueArray(labelIdArray).filter(isString);
};
